// LICENSE : MIT
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Dispatcher_1 = require("./Dispatcher");
var UseCaseContext_1 = require("./UseCaseContext");
var DispatcherPayloadMeta_1 = require("./DispatcherPayloadMeta");
var ErrorPayload_1 = require("./payload/ErrorPayload");
var UseCaseIdGenerator_1 = require("./UseCaseIdGenerator");
exports.defaultUseCaseName = "<Anonymous-UseCase>";
exports.isUseCase = function (v) {
    if (v instanceof UseCase) {
        return true;
    }
    else if (typeof v === "object" && typeof v.execute === "function") {
        return true;
    }
    return false;
};
/**
 * A `UseCase` class is inherited Dispatcher.
 * The user implement own user-case that is inherited UseCase class
 *
 * It similar to ActionCreator on Flux.
 *
 * ### Example
 *
 * ```js
 * import {UseCase} from "almin";
 * class AwesomeUseCase extends UseCase {
 *    execute(){
 *       // implementation own use-case
 *   }
 * }
 * ```
 */
var UseCase = /** @class */ (function (_super) {
    __extends(UseCase, _super);
    /**
     * Constructor not have arguments.
     */
    function UseCase() {
        var _this = _super.call(this) || this;
        _this.id = UseCaseIdGenerator_1.generateNewId();
        var own = _this.constructor;
        _this.name = own.displayName || own.name || exports.defaultUseCaseName;
        return _this;
    }
    /**
     * Return true if the `v` is a UseCase-like.
     */
    UseCase.isUseCase = function (v) {
        return exports.isUseCase(v);
    };
    Object.defineProperty(UseCase.prototype, "context", {
        /**
         * Get `context` of UseCase.
         * You can execute sub UseCase using UseCaseContext object.
         *
         * See following for more details.
         *
         * - [UseCaseContext](https://almin.js.org/docs/en/usecase-api.html)
         * - [Nesting UseCase](https://almin.js.org/docs/en/nesting-usecase.html)
         *
         * ### Example
         *
         * ```js
         * // Parent -> ChildUseCase
         * export class ParentUseCase extends UseCase {
         *     execute() {
         *         // execute child use-case using UseCaseContext object.
         *         return this.context.useCase(new ChildUseCase()).execute();
         *     }
         * }
         * export class ChildUseCase extends UseCase {
         *     execute() {
         *         this.dispatch({
         *             type: "ChildUseCase"
         *         });
         *     }
         * }
         * ```
         */
        get: function () {
            return new UseCaseContext_1.UseCaseContext(this);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Should does the UseCase execute?
     * Return `true` by default
     *
     * shouldExecute() is invoked before execute() when Executor execute the UseCase.
     * Currently, if shouldExecute() returns false, then execute() will not be invoked.
     *
     * @returns {boolean}
     */
    UseCase.prototype.shouldExecute = function () {
        var _ = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            _[_i] = arguments[_i];
        }
        return true;
    };
    /**
     * Dispatch `payload` object.
     *
     * `Store` or `Context` can receive the `payload` object.n
     */
    UseCase.prototype.dispatch = function (payload, meta) {
        // system dispatch has meta
        // But, when meta is empty, the `payload` object generated by user
        var useCaseMeta = meta
            ? meta
            : new DispatcherPayloadMeta_1.DispatcherPayloadMetaImpl({
                // this dispatch payload generated by this UseCase
                useCase: this,
                // parent is the same with UseCase. because this useCase dispatch the payload
                parentUseCase: null,
                // the user create this payload
                isTrusted: false,
                // Always false because the payload is dispatched from this working useCase.
                isUseCaseFinished: false
            });
        _super.prototype.dispatch.call(this, payload, useCaseMeta);
    };
    /**
     * `errorHandler` is called with error when error is thrown.
     */
    UseCase.prototype.onError = function (errorHandler) {
        return this.onDispatch(function (payload) {
            if (ErrorPayload_1.isErrorPayload(payload)) {
                errorHandler(payload.error);
            }
        });
    };
    /**
     * Throw error payload.
     *
     * You can use it instead of `throw new Error()`
     * This error event is caught by dispatcher.
     */
    UseCase.prototype.throwError = function (error) {
        var meta = new DispatcherPayloadMeta_1.DispatcherPayloadMetaImpl({
            useCase: this,
            isTrusted: true,
            isUseCaseFinished: false
        });
        var payload = new ErrorPayload_1.ErrorPayload({
            error: error
        });
        this.dispatch(payload, meta);
    };
    return UseCase;
}(Dispatcher_1.Dispatcher));
exports.UseCase = UseCase;
// Implement assertion
UseCase.prototype.execute = function () {
    throw new TypeError(this.name + " should be implemented UseCase#execute(): any");
};
//# sourceMappingURL=UseCase.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/almin/lib/src/UseCase.js
// module id = 193
// module chunks = 0